import { Grid, Typography } from "@mui/material";

const Footer = () => {
    return(
        <Grid container justifyContent='center'>
            <Grid item >
                <Typography variant="caption">© 2023 The University of Iowa</Typography>
            </Grid>
        </Grid>
    )
}

export default Footer;